import React, { useEffect, useRef, useState } from "react"
import Stats2 from "../../UI/Stats/Stats2"
import classes from './Overview.module.css'
import { alpha, useScrollTrigger } from "@mui/material"
import { checkAccessRestrictions, checkSiteConfig, getLiveViewCameras, listPartneredArcs, setArc, setScheduleOnly, setSiteActive, setsiteActive, setSiteLiveView, updateSiteDetails } from "../../../Api Methods/Api"
import useData from "rsuite/esm/InputPicker/hooks/useData"
import { useDispatch, useSelector } from "react-redux"
import { InputSwitch } from "primereact/inputswitch"
import confirmation from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/confirmation.png'
import Button1 from "../../UI/Button/Button1"
import Modal from "../../Modal/Modal"
import { Toast } from "primereact/toast"

const Overview = ({device, setShowChangeGroup, setShowChangeCCTV, setShowChangeName, setShowChangePortalName, setShowSuspendSite, groups, apiData, successModal, errorModal, setShowChangeSerialNumber, userCount}) => {
  console.log(device)
    const dispatch = useDispatch();
    const options = {
        year: 'numeric',
        month: 'long', 
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        seconds: "2-digit",
        hour12: false     
    };
    const [siteData, setSiteData] = useState(device[1])
    console.log(siteData)
    const group = siteData.name
    const macAddress = siteData.mac
    const siteID = siteData.key
    const sitetype = siteData.type
    const ipAddress = siteData.ip
    const uuid = siteData.uuid
    var IP = ""
    const online = siteData.online === "YES" ? "Online" : "Offline"
    const serialNumber = siteData.subGroup === "" ? "Not serialised" : siteData.subGroup
    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingArc, setIsLoadingArc] = useState(true)
    const [isLoadingRestriction, setIsLoadingRestriction] = useState(true)
    const creation = new Date(siteData.created)
    const creationDate = creation.toLocaleString('en-US', options)

    const lastUpdate = new Date(siteData.lastLoggedIn)
    const lastUpdateDate = lastUpdate.toLocaleString('en-US', options)

    const suspended = siteData.status === "available" ? "No" : "Yes"
    const portalSiteName = siteData.tag === "" ? "No name set" : siteData.tag
    const firmware = siteData.firmware
    const firmwareSplit = firmware.split('.')
    const firmwareMajor = firmwareSplit[0]
    const firmwareMinor = firmwareSplit[1]
    let type = siteData.type == ("CC" || "S") ? "Cloud Controller" : "Physical Controller"
    
    const showMac = siteData.type != "CC" && siteData.type != "S"
    let showIP = siteData.type != 'S' || true
    const [showCCTVIntegration, setShowCCTVIntegration] = useState(true)
    const [camectIntegrationType, setCamectIntegrationType] = useState("")
    const myAppSiteName = siteData.deviceName == '' ? "Not added to mobile app" : siteData.deviceName

    const [monitoredBy, setMonitoredBy] = useState("")
    const [monitoredByOptions, setMonitoredByOptions] = useState([])
    const [showMonitoredByDropdown, setShowMonitoredByDropdown] = useState(false)
    const [showMonitoredBy, setShowMonitoredBy] = useState(false)
    const [_supportsCamect, _setSupportsCamect] = useState("")
    const [_supportsMonitoredBy, _setSupportsMonitoredBy] = useState("")

    const [accessRestrictions, setAccessRestrictions] = useState("None")

    const [modalTitle, setModalTitle] = useState("Generate Access")
    
    const [modalComponent, setModalComponent] = useState()
    const [modalPageIndex, setModalPageIndex] = useState(null);

    const ModalDialog = useRef();
    const ClearStatesChildComponetRef = useRef();

    const [switchState, setSwitchState] = useState(siteData.active)
    const [liveViewSwitchState, setLiveViewSwitchState] = useState(siteData.liveViewEnabled)
    const [scheduleOnlySwitchState, setScheduleOnlySwitchState] = useState(siteData.scheduleOnly)

    const [liveViewCameras, setLiveViewCameras] = useState([]);
    const [liveViewCameraCount, setLiveViewCameraCount] = useState(0);

    const [countryCode, setCountryCode] = useState(siteData.country_code || "Not set")
    const countryCodeOptions = [
      { code: 'GB', name: 'United Kingdom' },
      { code: 'IE', name: 'Ireland' },
      { code: 'US', name: 'United States' },
      { code: 'CA', name: 'Canada' },
      { code: 'ZA', name: 'South Africa' },
      { code: 'AF', name: 'Afghanistan' },
      { code: 'AL', name: 'Albania' },
      { code: 'DZ', name: 'Algeria' },
      { code: 'AR', name: 'Argentina' },
      { code: 'AU', name: 'Australia' },
      { code: 'AT', name: 'Austria' },
      { code: 'BE', name: 'Belgium' },
      { code: 'BR', name: 'Brazil' },
      { code: 'BG', name: 'Bulgaria' },
      { code: 'CL', name: 'Chile' },
      { code: 'CN', name: 'China' },
      { code: 'CO', name: 'Colombia' },
      { code: 'HR', name: 'Croatia' },
      { code: 'CY', name: 'Cyprus' },
      { code: 'CZ', name: 'Czech Republic' },
      { code: 'DK', name: 'Denmark' },
      { code: 'EE', name: 'Estonia' },
      { code: 'FI', name: 'Finland' },
      { code: 'FR', name: 'France' },
      { code: 'DE', name: 'Germany' },
      { code: 'GR', name: 'Greece' },
      { code: 'HU', name: 'Hungary' },
      { code: 'IS', name: 'Iceland' },
      { code: 'IN', name: 'India' },
      { code: 'ID', name: 'Indonesia' },
      { code: 'IL', name: 'Israel' },
      { code: 'IT', name: 'Italy' },
      { code: 'JP', name: 'Japan' },
      { code: 'KE', name: 'Kenya' },
      { code: 'LV', name: 'Latvia' },
      { code: 'LT', name: 'Lithuania' },
      { code: 'LU', name: 'Luxembourg' },
      { code: 'MY', name: 'Malaysia' },
      { code: 'MT', name: 'Malta' },
      { code: 'MX', name: 'Mexico' },
      { code: 'NL', name: 'Netherlands' },
      { code: 'NZ', name: 'New Zealand' },
      { code: 'NO', name: 'Norway' },
      { code: 'PL', name: 'Poland' },
      { code: 'PT', name: 'Portugal' },
      { code: 'RO', name: 'Romania' },
      { code: 'SA', name: 'Saudi Arabia' },
      { code: 'SG', name: 'Singapore' },
      { code: 'SK', name: 'Slovakia' },
      { code: 'SI', name: 'Slovenia' },
      { code: 'KR', name: 'South Korea' },
      { code: 'ES', name: 'Spain' },
      { code: 'SE', name: 'Sweden' },
      { code: 'CH', name: 'Switzerland' },
      { code: 'TH', name: 'Thailand' },
      { code: 'TR', name: 'Turkey' },
      { code: 'UA', name: 'Ukraine' },
      { code: 'AE', name: 'United Arab Emirates' },
      { code: 'VN', name: 'Vietnam' }
    ];
    const [showCountryDropdown, setShowCountryDropdown] = useState(false)

    const [siteType, setSiteType] = useState(siteData.site_type || "Not set")
    const siteTypeOptions = [
      { key: 'RESIDENTIAL', label: 'Residential' },
      { key: 'OFFICE', label: 'Office' },
      { key: 'COMMERCIAL', label: 'Commercial' },
      { key: 'INDUSTRIAL', label: 'Industrial' },
      { key: 'CONSTRUCTION', label: 'Construction' },
      { key: 'WAREHOUSE', label: 'Warehouse / Storage' },
      { key: 'EDUCATION', label: 'Education' },
      { key: 'HEALTHCARE', label: 'Healthcare' },
      { key: 'PUBLIC', label: 'Public / Government' },
      { key: 'VACANT', label: 'Vacant property' },
      { key: 'UTILITY', label: 'Utility / Infrastructure' },
      { key: 'OTHER', label: 'Other' }
    ];
    const [showSiteTypeDropdown, setShowSiteTypeDropdown] = useState(false)


    const companyName = useSelector(state => state.auth.companyName);
    const isAllowed = companyName == "EyeSpyFX" || companyName == "KNOWIO" ? true : false
    //const isAllowed = false
    const toast = useRef(null);

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        };
    }

    useEffect(() => {
      const CheckSiteConfig = async () => {
        const config = await checkSiteConfig(apiData, siteData.id, dispatch)
        console.log(config)
        _setSupportsCamect(config[0].supportsCamect)

        if (config[1].supportsMonitoredBy == 1 || isAllowed){
          console.log("here")
          setShowMonitoredBy(true)
        }

        console.log(config[0])
        
        if (config[0].supportsCamect == 1) {
          setCamectIntegrationType(siteData.camectIntegrationType == "1" ? "Whole camect" : "Per camera arming")
          setIsLoading(false)
        } else {
          setShowCCTVIntegration(false)
        }
      }

      const ListPartneredArcs = async () => {
          const response = await listPartneredArcs(apiData, dispatch)
          const partneredArcsWithSelf = [
            { id: 0, name: 'Self monitored' },
            ...response.data
          ];
          
          const filteredPartneredArcs = partneredArcsWithSelf.filter(arc => arc.name != "Monitor Test" && arc.name != "Monitor Test 2")

          //This is for the UI - to display the current monitoredBy
          setMonitoredByOptions(filteredPartneredArcs)
          const monitoredByName = partneredArcsWithSelf.find(arc => arc.id == siteData.monitoredBy)?.name
          if (monitoredByName){ //If its not null
            setMonitoredBy(monitoredByName)
          } else {
            setMonitoredBy("Self monitored")
          }
          setIsLoadingArc(false)
      }

      const checkSiteRestriction = async () => {
        console.log("called")
        console.log(apiData)
        console.log(siteData.uuid)

          const response = await checkAccessRestrictions(siteData.uuid, apiData, dispatch)
          console.log(response)
          if (response.success){
            if (response.data.length > 0 && response.data[0].startTime && response.data[0].endTime){
              setAccessRestrictions(`From ${response.data[0].startTime} to ${response.data[0].endTime}`)
            } else {
              setAccessRestrictions(`None`)
            }
          }
          
          setIsLoadingRestriction(false)
      }

      const ListLiveViewCameras = async () => {
        console.log(apiData)
        console.log(siteData.uuid)
        const response = await getLiveViewCameras(apiData, siteData.uuid)
        console.log(response.data)
        if (response.success){
          setLiveViewCameras(response.data)
          setLiveViewCameraCount(response.data.length)
        }
      }

      CheckSiteConfig();
      ListPartneredArcs();
      checkSiteRestriction();
      if (siteData.liveViewEnabled){
        console.log("called")
        ListLiveViewCameras();
      }
    }, [])


    if (ipAddress == "10.250.20.173") {
            IP = "Server 1"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.20.155") {
            IP = "Server 2"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.20.175") {
            IP = "Server 3"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.20.165") {
            IP = "Server 4"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.20.224") {
            IP = "Server 5"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.20.98") {
            IP = "Server 6"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.20.184") {
            IP = "Server 7"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.20.130") {
            IP = "Server 8"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.20.21") {
            IP = "Server 9"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.1.22") {
            IP = "Upgrade Server"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.1.64") {
            IP = "FW Dev Server"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.20.178") {
            IP = "Server 10"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "10.250.20.8") {
            IP = "Davantis"
            showIP = false
            type = `Cloud controller (${IP})`
          } else if (ipAddress == "TypeS") {
            console.log("here?")
            IP = "Ajax/Dahua/Ganz";
            showIP = false
            type = `Cloud controller (G2CC)`
          } else {
            IP = ipAddress
            
          }

          console.log(sitetype)

          if (sitetype == "AB"){
            if (firmware == "1.7.14" || firmware == "1.7.15"){
              type = "Physical Controller (BPi)"
            } else if (firmware == "1.9.10"){
              type = "Physical Controller (RCK)"
            } else {
              type = "Physical Controller (RPi)"
            }
          } else if (sitetype == "ESP"){
            type = "Physical Controller (ESP)"
          } else if (sitetype == "S"){
            type = "G2CC"
          }

    const setMonitoringArc = async (arcID, arcName) => {
      const body = {
        "siteUUID": siteData.uuid, 
        "arcID" : arcID
      }
      console.log(body)
      const response = await setArc(apiData, body, dispatch)
      if (response.success){
        setMonitoredBy(arcName)
        successModal("Arc successfully updated")
      } else {
        //Error
        errorModal("Failed to update arc, please try again")
      }
    }

    const setSiteLocation = async (newLocale) => {
      const body = {
        "siteUUID": siteData.uuid, 
        "columnName": "country_code",
        "newValue": newLocale 
      }

      console.log(body)

      const response = await updateSiteDetails(apiData, body, dispatch)
      console.log(response)
    }

    const setSiteLocationType = async (newType) => {
      const body = {
        "siteUUID": siteData.uuid, 
        "columnName": "site_type",
        "newValue": newType 
      }

      console.log(body)

      const response = await updateSiteDetails(apiData, body, dispatch)
      console.log(response)
    }

    const HandleChangeSiteActive = async (newState) => {
      HandleCloseModal();
      const newStateText = newState == false ? "disable" : "enable"
      let body = {
        "uuid": siteData.uuid,
        "active": newState == false ? 0 : 1
      }

      const response = await setSiteActive(apiData, body, dispatch)
      if (response.success){
        successModal(`Site successfully ${newStateText}d`)
        //Set the site data so the switch state updates
        // setSiteData(prev => ({
        //   ...prev,
        //   active: newState == false ? 0 : 1
        // }));
        setSwitchState(newState == false ? 0 : 1)
      } else {
        errorModal(`Failed to ${newStateText} site, please try again`)
      }
    }

    const HandleChangeLiveView = async (newState) => {
      HandleCloseModal();
      const newLiveViewStateText = newState == true ? "enable" : "disable"
      let body = {
        "uuid": siteData.uuid,
        "liveViewEnabled": newState == false ? 0 : 1
      }

      const response = await setSiteLiveView(apiData, body, dispatch)
      if (response.success){
        successModal(`Live View successfully ${newLiveViewStateText}d`)
        //Set the site data so the switch state updates
        // setSiteData(prev => ({
        //   ...prev,
        //   liveViewEnabled: newState == false ? 0 : 1
        // }));
        setLiveViewSwitchState(newState == false ? 0 : 1)
      } else {
       errorModal(`Failed to ${newLiveViewStateText} Live View, please try again`)
     }
    }

    const HandleChangeScheduleOnly = async (newState) => {
      HandleCloseModal();
      const newScheduleOnlytateText = newState == true ? "enabled" : "disabled"
      const newScheduleOnlytateText2 = newState == true ? "enable" : "disable"

      let body = {
        "uuid": siteData.uuid,
        "scheduleOnly": newState == false ? 0 : 1
      }

      const response = await setScheduleOnly(apiData, body, dispatch)
      if (response.success){
        successModal(`Schedule only successfully ${newScheduleOnlytateText}`)
        setScheduleOnlySwitchState(newState == false ? 0 : 1)
      } else {
       errorModal(`Failed to ${newScheduleOnlytateText2} schedule only, please try again`)
     }
    }

    useEffect(() => {
      console.log(switchState)
    }, [switchState])

  

    const showConfirmActivePopup= () => {
      const newStateText = switchState == 1 ? "disable" : "enable"
        setModalTitle("Are you sure?")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <img className={classes.ModalIcon} src={confirmation}>
          </img>
          <br></br>
          <br></br>
          <div>
              <h3 style={{ textAlign: "center", color:"#858585"}}>{`Are you sure you want to ${newStateText} this site?`}</h3>
              {/* <h4 style={{ textAlign: "center", color:"#858585"}}>{`Please note this will disable the site for all users and prevent schedules & reminders from executing`}</h4> */}
          </div>   
          <br></br>
          <br></br>
          <div>
            <br></br>
            <Button1 onClick={() => HandleChangeSiteActive(switchState == 0 ? 1 : 0)} style={{width:"100%"}}>Yes</Button1>
            <br></br>
            <Button1 onClick={HandleCloseModal} style={{width:"100%"}}>No, cancel</Button1>
          </div>
        </div>
        )

        HandleShowModal();
    }

    const showConfirmLiveViewPopup= () => {
      if (isAllowed){
      const newStateText = liveViewSwitchState == 1 ? "disable" : "enable"
        setModalTitle("Are you sure?")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <img className={classes.ModalIcon} src={confirmation}>
          </img>
          <br></br>
          <br></br>
          <div>
              <h3 style={{ textAlign: "center", color:"#858585"}}>{`Are you sure you want to ${newStateText} live view for this site?`}</h3>
              {/* <h4 style={{ textAlign: "center", color:"#858585"}}>{`Please note this will disable the site for all users and prevent schedules & reminders from executing`}</h4> */}
          </div>   
          <br></br>
          <br></br>
          <div>
            <br></br>
            <Button1 onClick={() => HandleChangeLiveView(liveViewSwitchState == 0 ? 1 : 0)} style={{width:"100%"}}>Yes</Button1>
            <br></br>
            <Button1 onClick={HandleCloseModal} style={{width:"100%"}}>No, cancel</Button1>
          </div>
        </div>
        )

        HandleShowModal();
      } else {
          toast.current.show({ severity: 'error', summary: 'Unauthorsied', detail: 'Please contact your administrator to update live view for this site', life: 3000 });
      }
    }


    const showConfirmScheduleOnlyPopup= () => {
      if (isAllowed){
      const newStateText = scheduleOnlySwitchState == 1 ? "disable" : "enable"
        setModalTitle("Are you sure?")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <img className={classes.ModalIcon} src={confirmation}>
          </img>
          <br></br>
          <br></br>
          <div>
              <h3 style={{ textAlign: "center", color:"#858585"}}>{`Are you sure you want to ${newStateText} schedule only for this site?`}</h3>
              <h4 style={{ textAlign: "center", color:"#858585"}}>{`Please note this will disable the ability to add users and only allow schedules to execute`}</h4>
          </div>   
          <br></br>
          <br></br>
          <div>
            <br></br>
            <Button1 onClick={() => HandleChangeScheduleOnly(scheduleOnlySwitchState == 0 ? 1 : 0)} style={{width:"100%"}}>Yes</Button1>
            <br></br>
            <Button1 onClick={HandleCloseModal} style={{width:"100%"}}>No, cancel</Button1>
          </div>
        </div>
        )

        HandleShowModal();
      } else {
          toast.current.show({ severity: 'error', summary: 'Unauthorsied', detail: 'Please contact your administrator to update schedule only for this site', life: 3000 });
      }
    }

    return (
      <>
      <Toast ref={toast} />
      
      <Modal ref={ModalDialog} title={modalTitle} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "600px", minHeight: modalPageIndex === 1 ? "665px" : "250px"}} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
      </Modal>

        <div>

          <div className={classes.switchContainer}>
            <p style={{marginLeft:"20px", fontWeight:"500", fontSize:"18px", color:"#808080"}}>{siteData.active == 1 ? "Active site" : "Inactive site"}</p>
            <InputSwitch checked={switchState == 1 ? true : false} onChange={showConfirmActivePopup} />

            <p style={{marginLeft:"20px", fontWeight:"500", fontSize:"18px", color:"#808080", opacity: !isAllowed ? 0.5 : 1.0}}>{"Live view"}</p>
            <InputSwitch style={{ opacity: !isAllowed ? 0.5 : 1.0 }} checked={liveViewSwitchState == 1 ? true : false} onChange={showConfirmLiveViewPopup} />
          
            <p style={{marginLeft:"20px", fontWeight:"500", fontSize:"18px", color:"#808080", opacity: !isAllowed ? 0.5 : 1.0}}>{"Schedule only"}</p>
            <InputSwitch style={{ opacity: !isAllowed ? 0.5 : 1.0 }} checked={scheduleOnlySwitchState == 1 ? true : false} onChange={showConfirmScheduleOnlyPopup} />
          </div>

          <p style={{marginLeft:"20px", marginTop:"10px", fontWeight:"500", fontSize:"20px", color:"#808080"}}>Settings</p>
          <p style={{marginLeft:"20px", fontWeight:"400", fontSize:"16px", color:"#808080"}}>Click on the tiles to modify settings</p>

          <div className={classes.container}>
              <Stats2 title={"Portal site name"} value={portalSiteName} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangePortalName={setShowChangePortalName} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={true} />
              <Stats2 title={"My app site name"} value={myAppSiteName} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeName={setShowChangeName} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={true} />    
              <Stats2 title={"Serial number"} value={serialNumber} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={true}/>
              <Stats2 title={"Group"} value={group} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeGroup={setShowChangeGroup} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={true} />
              <Stats2 title={"Suspended"} value={suspended} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowSuspendSite={setShowSuspendSite} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={true} />
              {(showMonitoredBy && <Stats2 title={"Monitored by"} value={monitoredBy} status={""} isLoadingStats={isLoadingArc} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setMonitoringArc={setMonitoringArc} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={true} />)}
              {( showCCTVIntegration && <Stats2 title={"CCTV integration type"} value={camectIntegrationType} status={""} isLoadingStats={isLoading} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeCCTV={setShowChangeCCTV} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={true} />)}
              <Stats2 title={"Site location"} value={countryCodeOptions.find(c => c.code === countryCode)?.name ?? countryCode} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangePortalName={setShowChangePortalName} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={true} countryCodeOptions={countryCodeOptions} countryCode={countryCode} setCountryCode={setCountryCode} showCountryDropdown={showCountryDropdown} setShowCountryDropdown={setShowCountryDropdown} setSiteLocation={setSiteLocation}/>
              <Stats2 title={"Site type"} value={siteType} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangePortalName={setShowChangePortalName} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={true} siteType={siteType} setSiteType={setSiteType} showSiteTypeDropdown={showSiteTypeDropdown} setShowSiteTypeDropdown={setShowSiteTypeDropdown} siteTypeOptions={siteTypeOptions} setSiteLocationType={setSiteLocationType}/>
          </div>
      
  
      
          <p style={{marginLeft:"20px", marginTop:"50px", fontWeight:"500", fontSize:"20px", color:"#808080"}}>Information</p>
              <div className={classes.container}>
                  <Stats2 title={"Site ID"} value={siteID} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  <Stats2 title={"Firmware"} value={firmware} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  <Stats2 title={"Site type"} value={type} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  {( showIP == true && <Stats2 title={"IP address"} value={IP} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/> )}
                  {( showMac && <Stats2 title={"MAC address"} value={macAddress} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>)}
                  <Stats2 title={"Status"} value={online} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  {(<Stats2 title={"Access restrictions"} value={accessRestrictions} status={""} isLoadingStats={isLoadingRestriction} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeCCTV={setShowChangeCCTV}setShowChangeSerialNumber={setShowChangeSerialNumber}/>)}
                  {( online == "Offline" && <Stats2 title={"Offline since"} value={lastUpdateDate} status={""} isLoadingStats={false} isStatic={true} />)}
                  <Stats2 title={"Created"} value={creationDate} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  {/* {(_supportsCamect == 0 && <Stats2 title={"CCTV integration type"} value={camectIntegrationType} status={""} isLoadingStats={isLoading} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeCCTV={setShowChangeCCTV} />)} */}
                  { siteData.liveViewEnabled == 1 && <Stats2 title={"Linked camera count"} value={liveViewCameraCount} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber} />}
                  <Stats2 title={"No. of users"} value={userCount} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>

              </div>
          </div>
      </>
    )
}

export default Overview;